module.exports = __webpack_public_path__ + "static/media/twentyforloop_about_img.8ce27448.jpeg";